import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Solution } from '../components/Solution';
import { WhatYouGet } from '../components/WhatYouGet';
import { ForWho } from '../components/ForWho';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  // Initialize Meta Pixel and track PageView on mount
  useMetaPixel();
  return <div className="min-h-screen bg-[#FAF8F5] text-[#2D2A26] font-sans selection:bg-[#C4705A]/20" data-id="element-256">
      {/* Navigation / Logo Area */}
      <nav className="py-6 px-4 border-b border-[#2D2A26]/5" data-id="element-257">
        <div className="container mx-auto max-w-6xl flex justify-between items-center" data-id="element-258">
          <div className="font-serif font-bold text-xl text-[#2D2A26]" data-id="element-259">
            Reset<span className="text-[#C4705A]" data-id="element-260">7×3</span>
          </div>
          <button className="text-sm font-medium text-[#2D2A26]/70 hover:text-[#C4705A] transition-colors" data-id="element-261">
            Acceso Miembros
          </button>
        </div>
      </nav>

      <main data-id="element-262">
        <Hero data-id="element-263" />
        <PainPoints data-id="element-264" />
        <Solution data-id="element-265" />
        <WhatYouGet data-id="element-266" />
        <ForWho data-id="element-267" />
        <CTASection data-id="element-268" />
      </main>

      <Footer data-id="element-269" />
    </div>;
}